import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=48afc5b5&scoped=true"
var script = {}
import style0 from "./admin.vue?vue&type=style&index=0&id=48afc5b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48afc5b5",
  null
  
)

export default component.exports